var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-form"},[_vm._l((_vm.formData),function(inputData){return _c('custom-input',{key:inputData.name,attrs:{"inputData":inputData}})}),_vm._v(" "),_c('div',{staticClass:"cont-btn-c"},[_c('button',{staticClass:"continue-button",attrs:{"disabled":!_vm.valid},on:{"click":_vm.submitFields}},[_vm._t("default",[_vm._v("Submit")])],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26838f12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!../interactives-form/src/App.vue
// module id = i2BW
// module chunks = 1